import { useState } from "react";
import { useTranslation } from "react-i18next";

const faqKeys = ["f1", "f2", "f3", "f4", "f5"];

export default function ContactFaq() {
  const { t } = useTranslation();
  const [open, setOpen] = useState<string | null>("f1");

  return (
    <section className="py-16 border-t" style={{ borderColor: "var(--border-color)", backgroundColor: "var(--bg-surface)" }}>
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-10">
          <span
            className="inline-block text-xs font-semibold uppercase tracking-widest mb-4 px-3 py-1 rounded-full"
            style={{ backgroundColor: "rgba(34,197,94,0.1)", color: "var(--accent)" }}
          >
            {t("contact.faq.label")}
          </span>
          <h2 className="text-2xl font-bold" style={{ color: "var(--text-primary)" }}>
            {t("contact.faq.title")}
          </h2>
        </div>

        <div className="space-y-3">
          {faqKeys.map((key) => {
            const isOpen = open === key;
            return (
              <div
                key={key}
                className="rounded-xl overflow-hidden"
                style={{
                  backgroundColor: "var(--bg-base)",
                  border: `1px solid ${isOpen ? "rgba(74,222,128,0.3)" : "var(--border-color)"}`,
                }}
              >
                <button
                  className="w-full flex items-center justify-between px-5 py-4 text-sm font-medium text-left cursor-pointer"
                  style={{ color: "var(--text-primary)" }}
                  onClick={() => setOpen(isOpen ? null : key)}
                >
                  {t(`contact.faq.${key}.q`)}
                  <i
                    className={`ri-arrow-down-s-line text-lg transition-transform shrink-0 ml-4 ${isOpen ? "rotate-180" : ""}`}
                    style={{ color: isOpen ? "var(--accent)" : "var(--text-muted)" }}
                  ></i>
                </button>
                {isOpen && (
                  <div
                    className="px-5 pb-4 text-xs leading-relaxed"
                    style={{ color: "var(--text-muted)" }}
                  >
                    {t(`contact.faq.${key}.a`)}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}